// FestivalImage.tsx
import React, { useCallback, useMemo } from 'react'
import { ShopbyFestivalComponents } from '../../@types/aboutfishing'
import FestivalNotice from './FestivalNotice'
import { Link } from 'react-router-dom'
import { useAppContext } from '../provider/AppProvider'
import { AFWebLinkType, RNPostMessage } from '../../js/postMessage'

interface FestivalImageProps {
  el: ShopbyFestivalComponents
  innerRef: React.RefObject<HTMLDivElement>
  isMobile: boolean
  getScrollMarginTop: string
  handlePostMessage: (message: { actionType: string; params: { url: string } }) => void
}

const FestivalImage: React.FC<FestivalImageProps> = ({
  el,
  innerRef,
  isMobile,
  getScrollMarginTop,
  handlePostMessage,
}) => {
  const { isAppView } = useAppContext()

  const imageUrl = useMemo(
    () => (isMobile ? el.mobileImageUrl : el.pcImageUrl),
    [isMobile, el.mobileImageUrl, el.pcImageUrl]
  )

  const appLinkClickHandler = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault()
      if (isAppView) {
        RNPostMessage(AFWebLinkType.moveToLink, {
          url: el.appLandingPage,
        })
      } else {
        window.location.href = el.appLandingPage
      }
    },
    [el.appLandingPage, handlePostMessage]
  )

  const renderImageLink = (
    url: string,
    imageUrl: string,
    onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void
  ) => (
    <Link to={url} onClick={onClick}>
      <img src={imageUrl} alt='' />
    </Link>
  )

  return (
    <>
      <div
        className='image center section'
        id={`section${el.id}`}
        ref={innerRef}
        style={{ scrollMarginTop: getScrollMarginTop }}
      >
        {el.appLandingPage || el.webLandingPage ? (
          isAppView ? (
            renderImageLink(el.appLandingPage, imageUrl, appLinkClickHandler)
          ) : (
            renderImageLink(el.webLandingPage, imageUrl)
          )
        ) : el.isNotable ? (
          <FestivalNotice el={el} />
        ) : (
          <img src={imageUrl} alt='' />
        )}
      </div>
    </>
  )
}

export default FestivalImage
